import React from 'react';
import "./Header.css";
import Navbar from '../Navbar/Navbar';
import {Link} from "react-router-dom";

const Header = () => {
  return (
    <div className='header flex flex-col' id = "header">
        <Navbar />

        <div className='container flex'>
            <div className='header-content'>
                <h2 className='text-uppercase text-white op-07 fw-6 ls-2'>Gestión Integral de Inmuebles</h2>
                <h1 className='text-white fw-6 header-title'>Tu renta <span className='text-brown'>garantizada</span> cada mes, sin mover un dedo y con la tranquilidad de un profesional</h1>
                <div className='btn-groups flex'>
                  <Link to="/contact" className='btn-item bg-dark fw-4 ls-2'>Quiero una valoración gratuita</Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Header